import { gsap } from 'gsap'
import { fades } from 'settings/fades'
import { delayCallBack } from 'utils/Delay'

export function enableFade(container) {
  let state = true

  function complete(cb) {
    if(cb){
      delayCallBack(0.5).then(cb)
    }
    else{

      container.visibility(state, 'fade')
    }

  }

  function toFade(value, cb) {

    if (state != value) {
      const { duration, from, to } = fades[+value]
      state = value

      container.visibility(true, 'fade')

      gsap.killTweensOf(container)
      gsap.fromTo(container, duration, from, to).then(complete(cb))
    }

  }

  return toFade
}
